// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"fefc78b7","274":"98e8a546"}[chunkId] + ".chunk.js";
};